import {HStack, VStack, Text} from '@chakra-ui/react';
import React from 'react';

export const Header = ({title, description, right, left}) => {

    return (
        <HStack justify="center" align="center" py="20px" w="100%">
            <HStack flex={1} justify="flex-start" align="center" px="10px">
                {left}
            </HStack>
            <VStack justify="center" align="center">
                <Text fontSize="lg" fontWeight="bold" color="secondary.500">{ title }</Text>
                { description && <Text fontSize="sm" color="secondary.500" fontWeight="500">{ description }</Text>}
            </VStack>
            <HStack flex={1} justify="flex-end" align="center" px="10px">
                {right}
            </HStack>
        </HStack>
    );
};

export default Header;
